

const BENEFICIARY_FIRST_NAME = parseInt(process.env.REACT_APP_BENEFICIARY_FIRST_NAME_REQUIRED_FIELD_ID, 10);
const BENEFICIARY_LAST_NAME = parseInt(process.env.REACT_APP_BENEFICIARY_LAST_NAME_REQUIRED_FIELD_ID, 10);

export default class Beneficiary {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.id = jsonResponse["id"];
            this.registrationId = jsonResponse["registration-id"];
            this.beneficiaryName = jsonResponse["beneficiary-name"];
            this.countryId = jsonResponse["country-id"];
            this.countryName = jsonResponse["country-name"];
            this.payoutMethodId = jsonResponse["payout-method-id"];
            this.payoutMethodName = jsonResponse["payout-method-name"];
            this.payoutPartnerId = jsonResponse["payout-partner-id"];
            this.payoutPartnerName = jsonResponse["payout-partner-name"];
            this.currencyId = jsonResponse["currency-id"];
            this.currencyName = jsonResponse["currency-name"];
            this.quotationType = jsonResponse["quotation-type"];
            this.amount = jsonResponse["amount"];
            this.active = jsonResponse["active"];
            this.deleted = jsonResponse["deleted"];
            this.requiredFields = jsonResponse["required-fields"];

            this.beneficiaryLetter = this.beneficiaryName.charAt(0);
        }
    }

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["id"] = obj.id;
        jsonObj["registration-id"] = obj.registrationId;
        jsonObj["beneficiary-name"] = obj.beneficiaryName;
        jsonObj["country-id"] = obj.countryId;
        jsonObj["country-name"] = obj.countryName;
        jsonObj["payout-method-id"] = obj.payoutMethodId;
        jsonObj["payout-method-name"] = obj.payoutMethodName;
        jsonObj["payout-partner-id"] = obj.payoutPartnerId;
        jsonObj["payout-partner-name"] = obj.payoutPartnerName;
        jsonObj["currency-id"] = obj.currencyId;
        jsonObj["currency-name"] = obj.currencyName;
        jsonObj["quotation-type"] = obj.quotationType;
        jsonObj["amount"] = obj.amount;
        jsonObj["active"] = obj.active;
        jsonObj["deleted"] = obj.deleted;
        jsonObj["quotation-reference"] = obj.quotationReference;
        jsonObj["required-fields"] = obj.requiredFields;

        return jsonObj;
    };

    static createUpdatedBeneficiary(originalBeneficiary, beneficiaryName, quoteRequest, quoteResponse, requiredFields) {
        let newBeneficiary = {...originalBeneficiary};
        newBeneficiary.beneficiaryName = beneficiaryName;
        newBeneficiary.countryId = quoteRequest.countryId;
        newBeneficiary.payoutMethodId = quoteRequest.payoutMethodId;
        newBeneficiary.payoutPartnerId = quoteRequest.payoutPartnerId;
        newBeneficiary.currencyId = quoteRequest.currencyId;
        newBeneficiary.quotationType = quoteRequest.quotationType;
        newBeneficiary.amount = quoteRequest.amount;
        newBeneficiary.quotationReference = quoteResponse === null || quoteResponse.quotationReference === null ? "" : quoteResponse.quotationReference;
        newBeneficiary.requiredFields = requiredFields;

        return newBeneficiary;
    }

    static generateBeneficiaryName(capturedValues) {

        let beneficiaryFirstName = "";
        let beneficiaryLastName = "";

        capturedValues.forEach(capturedValue => {
            let fieldId = parseInt(capturedValue["required-field-id"], 10);
            if (fieldId === BENEFICIARY_FIRST_NAME) {
                beneficiaryFirstName = capturedValue["required-field-value"];
            } else if (fieldId === BENEFICIARY_LAST_NAME) {
                beneficiaryLastName = capturedValue["required-field-value"];
            }
        });
        return beneficiaryFirstName + " " + beneficiaryLastName;
    }

}